import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import NotificationDetailsComponent from "../../components/NotificationDetailsComponent";
import { FaArrowLeft } from "react-icons/fa6";
import SuggestedFollows from "../../components/SuggestedFollow";
import LatestNews from "../../components/LatestNews";

function NotificationDetails() {
  const location = useLocation();
  const navigate = useNavigate();

  const notification = location.state?.notification;

  useEffect(() => {
    if (notification?.id) {
      const readNotifications = JSON.parse(localStorage.getItem('readNotifications') || '[]');

      if (!readNotifications.includes(notification.id)) {
        localStorage.setItem(
          'readNotifications',
          JSON.stringify([...readNotifications, notification.id])
        );
      }
    }
  }, [notification]);

  if (!notification) {
    return <h2>Notification Not Found</h2>;
  }

  return (
    <div className="club-details">
      <div className="club-post-section">
        {/* Back Button */}
        <div className="back-button" onClick={() => navigate(-1)}>
          <span><FaArrowLeft className="back-icon" /></span> <h2>Notifications</h2>
        </div>
        {/* Notification Details Component */}
        <NotificationDetailsComponent notification={notification} />
      </div>
      <div className="right-side-bar">
        <LatestNews />
        <SuggestedFollows />
      </div>
    </div>
  );
}

export default NotificationDetails;


